import React from 'react';

import type { OptionsFromRequest } from '../../../../core/system/rendering/types.js';
import type { FrapiList, FrapiListItem } from '../../../types/frapi-types.js';

import RestaurantsWidget from '../front/RestaurantsWidget.js';

type RelatedListProps = {
  data: FrapiList;
  options: OptionsFromRequest;
};

const DEFAULT_PROPERTIES = {
  h1: 'Topplister fra våre anmeldere',
  titleTag: '',
  metaDescription: '',
  description: '',
  imageId: '',
  linksTo: '',
  update: '',
};

const transformToFrapiListItem = (
  related: Record<string, string>,
): FrapiListItem => ({
  locale: 'no',
  id: related.id,
  type: 'list',
  properties: {
    title: related.title,
    image: related.imageId,
    section: related.section,
  },
});

const RelatedList: React.FC<RelatedListProps> = ({ data, options }) => {
  const { properties } = data;
  const { siteVersion } = options;

  const relatedLists =
    'linksTo' in properties && properties.linksTo
      ? JSON.parse(properties.linksTo).map(transformToFrapiListItem)
      : [];

  const isMobile = siteVersion === 'phone';

  return (
    relatedLists.length > 0 && (
      <RestaurantsWidget
        data={{ items: relatedLists, properties: DEFAULT_PROPERTIES }}
        isMobile={isMobile}
      />
    )
  );
};

export default RelatedList;
